<template>
    <div id="CFPageDetail">
        <a-spin :spinning="isLoading">
            <a-row>
                <a-col class="headerDesc">
                    <span class="descSub">{{caseName}}:</span>
                    <span>{{caseDesc}}  <span v-if="pdfFileName" class="linkAction" @click="gotoPdfView">here</span> </span>
                </a-col>
            </a-row>
            <a-row>
                <a-col class="titleArea">Request information</a-col>
            </a-row>
            <a-row v-for="(item, index) in responseParam" :key="index">
                <a-row>
                    <a-col class="subTitle">{{item.title}}</a-col>
                </a-row>
                <a-row type="flex" class="subsTitle" v-if="item.title !== 'Your Response'">
                    <a-col v-for="(subItem, subIndex) in item.fields" :key="subIndex" span="12">
                        <span>{{subItem.title}}</span> :
                        <span>{{subItem.value}}</span>
                    </a-col>
                </a-row>
            </a-row>

            <a-row class="m-T-30">
                <a-col :span="24" class="titleArea">Your Response</a-col>
            </a-row>
            <a-row>
                <div class="tabStyle">
                    <a-tabs type="card" default-active-key="0" @change="tabChange">

                        <a-tab-pane v-for="(item, index) in responseField" :key="index" :tab="item.title">
                            <AcceptPart :isShowAll="isShowAllInput"
                                        :changeAcceptButtonshow="isOnlyShowAccept"
                                        :buttonCode="item.outcome"
                                        :activeKey="activeKey"
                                        :inputConfig="item.fields"
                                        :isCanEdit="isCanEdit"
                                        @accept="accept"
                                        @uploadFile="getUploadFile">
                            </AcceptPart>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </a-row>

        </a-spin>
    </div>
</template>

<script>
    import {getViewDetail, feedBack} from './CFDetailApiMethod'
    import {YOUR_RESPONSE_CONFIG, PDFFileConfig} from './CFPageDetailConfig'
    import AcceptPart from './AcceptPart'
    import Rejection from './Rejection'

    export default {
        name: 'CFPageDetail',
        components: {
            AcceptPart,
            Rejection
        },
        data() {
            return {
                uuid: '',
                caseId: '',
                buyType: '',
                caseName: '',
                caseDesc: '',
                descriptionUrl: '',
                activeKey: 0,
                isLoading: false,
                fileData: null,
                isCanEdit: true,
                isShowAllInput: false,
                isOnlyShowAccept: false,
                responseParam: [],
                responseField: [],
                IdentifiersArray: [],
                requestDetailArray: [],
                addressInfomationArray: [],
                fileSize: 0,
                pdfFileName: ''
            }
        },
        destroyed() {
        },
        created() {
            this.uuid = this.$route.query.uid
            this.requestDetail()
        },
        methods: {
            tabChange(e) {
                this.activeKey = e
            },
            getUploadFile(fileData) {
                this.fileSize = fileData.size
                this.fileData = fileData.file
            },
            requestDetail() {
                this.isLoading = true
                getViewDetail(this.uuid).then(res => {
                    this.isLoading = false
                    this.caseId = res.caseId
                    this.buyType = res.buType
                    this.isCanEdit = res.edit == '1'
                    this.caseName = res.caseName
                    this.caseDesc = res.caseDesc
                    var outCome = res.lovOutCome + ''
                    const fff = this.buyType + '-' + this.caseName
                    this.pdfFileName = PDFFileConfig[fff.toLowerCase()]

                    this.responseParam = res.params.params
                    if (Array.isArray(this.responseParam)) {
                        this.responseParam.forEach(item => {
                            if (item.fields && Array.isArray(item.fields)) {
                                item.fields.forEach(ssItem => {
                                    if (ssItem.fieldName === 'lvo_requestinformation') {
                                        if (ssItem.value) {
                                            var lastSre = ssItem.value.substring(ssItem.value.length - 2)
                                            if (lastSre == '02') {
                                                this.isShowAllInput = true
                                            } else {
                                                this.isShowAllInput = false
                                            }
                                        }
                                    }
                                })
                            }
                        })
                    }
                    const pr = res['params']
                    var aResponseFields = this.setYourResponseArray(pr['resp'])
                    if (outCome && outCome.substring(outCome.length - 5) === '90009') {
                        this.isOnlyShowAccept = true
                    }

                    if (Array.isArray(aResponseFields)) {
                        aResponseFields.forEach(res => {
                            if (res.fields && Array.isArray(res.fields)) {
                                var sss = []
                                var isIssue = false
                                res.fields.forEach(items => {
                                    if (items.dataIndex === 'lvo_etatoredeliveryaddress') {
                                        isIssue = true
                                        sss.push(items)
                                    }
                                })
                                if (this.isShowAllInput) {
                                } else {
                                    if (isIssue) res.fields = sss
                                }
                            }
                        })
                        if (this.isOnlyShowAccept) {
                            aResponseFields.forEach(res => {
                                if (res.title === 'Accept') {
                                    this.responseField = [{title: 'Accept', fields: [], outcome: res['outcome'] ? res['outcome']: '0000000'}]
                                }
                            })
                        } else {
                            this.responseField = aResponseFields
                        }
                    }
                })
            },
            setYourResponseArray(responseArray) {
                var resultArray = []
                if (Array.isArray(responseArray)) {
                    responseArray.forEach(res => {
                        var fields = []
                        // console.log(res);
                        if (Array.isArray(res.fields)) {
                            res.fields.forEach(item => {
                                var pageItem = YOUR_RESPONSE_CONFIG[item.fieldName]
                                if (pageItem) {
                                    pageItem.value = item.value
                                    pageItem.title = item.title ? item.title : pageItem.title
                                    pageItem.valid = item.exits ? item.exits : false
                                    pageItem.code = item.fieldName ? item.fieldName : pageItem.code
                                    if (pageItem.inputStyle === 'select') {
                                        if (item.params) {
                                            const selestArr = Object.keys(item.params)
                                            let bb = []
                                            if (Array.isArray(selestArr) && selestArr.length > 0) {
                                                selestArr.forEach(sit => {
                                                    bb.push({
                                                        name: sit,
                                                        value: item.params[sit]
                                                    })
                                                })
                                            }
                                            pageItem.selectArray = bb
                                        }
                                    }
                                    fields.push(pageItem)
                                } else {
                                    // console.log('have no case : ', item)
                                }
                            })
                        }
                        resultArray.push({
                            title: res.title,
                            fields: fields,
                            outcome: res.outcome,
                        })
                    })
                }
                return resultArray
            },
            accept(data) {
                const sizeM = this.fileSize / 1024 / 1024
                if (sizeM > 5) {
                    this.$error({
                        title: 'Error',
                        content: 'Files must smaller than 5MB!',
                    });
                    return
                }
                this.sendMsg(data.res, data.buttonCode)
            },
            sendMsg(data, buttonCode) {
                var param = {}
                data.forEach(res => {
                    if (res.inputStyle === 'date' || res.inputStyle === 'dateTime') {
                        param[res.code] = this.$moment(res.value).utc(false)
                    } else if (res.inputStyle === 'time') {
                        param[res.code] = this.$moment(res.value).utc(false)
                    } else if (res.inputStyle === 'dateD') {
                        param[res.code] = this.$moment(res.value).utc(false)
                    } else if (res.inputStyle === 'upload') {

                    } else if (res.inputStyle === 'number') {
                        param[res.code] = parseFloat(res.value)
                    } else {
                        param[res.code] = res.value
                    }
                })

                const formData = new FormData()
                if (this.fileData) {
                    this.fileData.forEach(file => {
                        if (file.originFileObj) {
                            formData.append('files', file.originFileObj)
                        } else {
                            formData.append('files', file)
                        }
                    })
                }

                var sendParameters = {
                    uuid: this.uuid,
                    caseId: this.caseId,
                    outcome: buttonCode,
                    attachment: false,
                    params: param
                }

                formData.append('carrierRequest', JSON.stringify(sendParameters))
                this.isLoading = true
                feedBack(this.buyType, formData).then(res => {
                    this.isLoading = false
                    const err = res['errors']
                    const war = res['warnings']
                    if ((err && err.length > 0) || (war && war.length > 0)) {
                        var msg = err[0] ? err[0] : (war[0] ? war[0] : 'Error')
                        this.$error({
                            title: 'Error',
                            content: msg,
                        });

                    } else {
                        this.$message.success('Success')
                        this.$router.go(-1)
                    }
                }).catch(() => {
                    this.isLoading = false
                })
            },
            gotoPdfView() {
                if (this.pdfFileName && this.pdfFileName.length > 0) {
                    let routeData = window.location.origin + '/#/pdf?pdfName=' + this.pdfFileName
                    window.open(routeData, '_blank');
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #CFPageDetail {
        text-align: left;
        padding-bottom: 40px;

        .headerDesc {
            border: 1px solid #91d5ff;
            background-color: #e6f7ff;
            padding: 10px;
            font-weight: 400;

            .descSub {
                font-weight: 800;
            }
        }

        .titleArea {
            padding: 5px;
            border-bottom: 1px solid #91d5ff;
            color: #027DB4;
            font-weight: 800;
            font-size: 16px;
        }

        .subTitle {
            padding: 10px;
            color: #222;
            font-weight: 800;
            font-size: 16px;
        }

        .subsTitle {
            margin-left: 20px;
            font-size: 14px;
        }

        .subDesc {
            padding: 10px;
        }

        .m-T-30 {
            margin-top: 30px;
        }

        .p-20 {
            padding: 20px;
        }

        .wordwrap {
            word-wrap: break-word;
            padding: 10px;
        }

        .buttonCss {
            margin-left: 20px;
            font-size: 14px;
            font-weight: 800;
        }

        .ant-tabs-nav .ant-tabs-tab-active {
            color: #027DB4;
            font-weight: 500;
        }

        .tabStyle {
            color: #222;
            width: 60%;
            min-height: 300px;
            margin-top: 20px;
        }

        .tabStyle > .ant-tabs-card > .ant-tabs-content {
            height: 120px;
            margin-top: -16px;
        }

        .tabStyle > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
            background: #fff;
            padding: 16px;
        }

        .tabStyle > .ant-tabs-card > .ant-tabs-bar {
            border-color: #fff;
        }

        .tabStyle > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
            border-color: transparent;
            background: transparent;
        }

        .tabStyle > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
            border-color: red;
            color: yellow;
            background: red;
        }
        .linkAction {
            color: #1890ff;
            font-size: 14px;
            font-weight: 500;
        }
    }

</style>
